/**
 * Las categorías llegan de la API en mayúsculas ("CUIDADO CAPILAR").
 * Para mostrarlas usamos mayúscula inicial y el resto en minúscula, que es lo
 * que corresponde en español: "Cuidado capilar".
 */
export const toSentenceCase = (text) => {
	if (!text) return "";
	const lower = text.toLowerCase();
	return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export default toSentenceCase;
